import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import { message } from 'antd';
import actions from './actions';
import { post } from 'bukku/shared/ApiService';
import { t } from '@lingui/macro';

export function* createOtpRequest() {
    yield takeEvery(actions.OTP_CREATE_REQUEST,
        function* (request, context) {
            try {
                yield call(
                    post, '/public/otps', request.requestData, context,
                );

                //OK
                yield put({
                    type: actions.OTP_CREATE_SUCCESS,
                });
            }
            catch (error) {
                yield put({
                    type: actions.OTP_CREATE_ERROR,
                    error,
                });
            }
        });
}

export function* createOtpSuccess() {
    yield takeEvery(actions.OTP_CREATE_SUCCESS, function* () {
        yield message.success(t`An OTP has been sent to your email address.`);
    });
}

export function* createOtpError() {
    yield takeEvery(actions.OTP_CREATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createOtpRequest),
        fork(createOtpSuccess),
        fork(createOtpError),
    ]);
}
